var make = require('./make_');
var arrContains = require('../array/contains');
var objContains = require('../object/contains');

    /**
     */
    module.exports = make(arrContains, objContains);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/contains.js
// module id = 1572
// module chunks = 0 1 2